var exports = {
  "zr": "TavlaBoard.module__root___UTFMUz",
  "KE": "TavlaBoard.module__toolbar___UTFMUz",
  "aR": "TavlaBoard.module__dice___UTFMUz",
  "F_": "TavlaBoard.module__die___UTFMUz",
  "O1": "TavlaBoard.module__timer___UTFMUz",
  "no": "TavlaBoard.module__board___UTFMUz",
  "zx": "TavlaBoard.module__point___UTFMUz",
  "ai": "TavlaBoard.module__number___UTFMUz",
  "w1": "TavlaBoard.module__checker___UTFMUz",
  "U9": "TavlaBoard.module__count___UTFMUz",
  "M0": "TavlaBoard.module__bar___UTFMUz",
  "AU": "TavlaBoard.module__off___UTFMUz",
  "o1": "TavlaBoard.module__actions___UTFMUz",
  "z3": "TavlaBoard.module__error___UTFMUz",
};

module.exports = exports;
